import {useEffect, useState} from "react";
import {useTenant} from "../context/tenant";
import {hasCookieConsent} from "./cookie-consent-banner";

export function TrackingCodeInjector() {
	const {tenant} = useTenant();
	const [consented, setConsented] = useState(hasCookieConsent);

	useEffect(() => {
		function onConsentChanged() {
			setConsented(hasCookieConsent());
		}
		window.addEventListener("cookie-consent-changed", onConsentChanged);
		return () => window.removeEventListener("cookie-consent-changed", onConsentChanged);
	}, []);

	useEffect(() => {
		const trackingCode = tenant?.trackingCode;
		if (!trackingCode || !consented) {
			return;
		}

		const range = document.createRange();
		range.selectNode(document.head);
		const fragment = range.createContextualFragment(trackingCode);

		// Track injected nodes for cleanup
		const injectedNodes: Node[] = [];
		fragment.childNodes.forEach(node => injectedNodes.push(node));

		document.head.appendChild(fragment);

		return () => {
			injectedNodes.forEach(node => {
				if (node.parentNode === document.head) {
					document.head.removeChild(node);
				}
			});
		};
	}, [tenant?.trackingCode, consented]);

	return null;
}
